module.exports = __webpack_public_path__ + "img/badge-list-thumb-083.804f30a5.png";